module.exports = { src: __webpack_public_path__ + "media/tile-4-overlay.b491a7cb.webp", width: 365, height: 400 };